import { render } from "./SnippetNavigation.vue?vue&type=template&id=c253236a"
import script from "./SnippetNavigation.vue?vue&type=script&lang=js"
export * from "./SnippetNavigation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\vscode_playground\\WeinfinderV3\\weinfinder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__